module.exports = __webpack_public_path__ + "static/img/kv.e8d4709.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index/kv.jpg
// module id = aHO2
// module chunks = 7